export const LUXURY_PLUS_PATHS = {
  LANDING_PAGE: 'LuxuryPlus',
  ACCOUNT_MANAGEMENT_PAGE: 'account/lux-plus',
  TERMS_AND_CONDITIONS_PAGE: 'lux-plus-terms-and-conditions',
} as const

export const LUXURY_PLUS = {
  PROGRAM_NAME: 'LuxPlus+',
  REFUND_ELIGIBILITY_PERIOD_IN_DAYS: 28,
} as const

/**
 * The number of days before a user can no longer cancel their membership
 */
export const LuxPlusCancellationPolicyDays = 28
